var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-cell-container"},[_c('button',{class:[
      'notes-btn',
      {
        'has-note': _vm.hasNote,
        'always-visible': _vm.isAlwaysVisible,
      },
    ],attrs:{"title":!_vm.isSubscribedUser ? 'Доступно при наличии платной подписки' : ''},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"click":function($event){$event.stopPropagation();return _vm.openNote.apply(null, arguments)}}},[_c('PenIcon')],1),_c('div',{staticClass:"checkbox-container",class:{ children: _vm.row.parentId },on:{"click":_vm.toggleSelect}},[_c('div',{staticClass:"checkbox-ui",class:{
        checked: _vm.isChecked,
        indeterminate: !_vm.isChecked && _vm.isIndeterminate,
      }},[_c('span',{staticClass:"checkmark"})])]),(_vm.tableContext.hasChildren(_vm.row.id) && !_vm.row.parentId)?_c('span',{staticClass:"icon-container",class:{ expanded: _vm.isExpanded },on:{"click":_vm.toggleExpand}},[_c('CollapseIcon',{staticClass:"icon"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }